import {del, exportPdf, get, post, exportXls} from "@/utils/methods";
import {useMessage} from "@/utils/useMessage";
const {createMessage } = useMessage();

//产品
enum Api {
  Add = '/system/memberProduct/add',

  Edit = '/system/memberProduct/edit',

  List = '/system/memberProduct/productList',

  Index = '/system/memberProduct/index',

  MemberProductList = '/system/memberProduct/list',

  MemberProductAllList = '/system/memberProduct/listAll',

  ListDocumentConf = '/system/product/queryProductDocumentConfListByMainId',

  ListFanganDoc = '/system/productFanganDoc/list',

  Detail = '/system/memberProduct/queryByCode',

  Price = '/system/memberProductFanganConf/getListByFanganCode',

  QuestionList = '/system/productQuestion/list',

  ProductListByType = '/system/memberProduct/productListByType',

  DownloadPdf = '/system/product/downloadPdf',

  DownloadExcel = '/system/product/downloadExcel',

  HistoryPdf = '/system/productFanganPdf/getHistoryPdf',

  UploadPdfUrl = '/system/productFanganPdf/uploadPdf',

  ProductUpDetail = '/system/product/queryByCodeStatus',

  ProductDetail = '/system/product/queryByCode',
}
export const getUploadPdfUrl = process.env.VITE_GLOB_DOMAIN_URL + process.env.VITE_GLOB_API_URL + Api.UploadPdfUrl // 设置API的基础URL

export const getHistoryPdf = (productCode, fanganCode) => {
  let params = {"productCode": productCode, "fanganCode": fanganCode}
  return get(Api.HistoryPdf, params)
}

export const list = (params = {}) => {
  return get(Api.List, params)
}

export const productListIndex = (params = {}) => {
  return get(Api.Index, params)
}

export const productListByType = () => {
  return get(Api.ProductListByType)
}

export const getMemberProductListAll = (params = {}) => {
  return get(Api.MemberProductAllList, params)
}

export const getMemberProductList = (params = {}) => {
  return get(Api.MemberProductList, params)
}

export const getQuestionList = (params = {}) => {
  return get(Api.QuestionList, params)
}

export const listDocumentConf = (params = {}) => {
  return get(Api.ListDocumentConf, params)
}

export const listFanganDoc = (params = {}) => {
  return get(Api.ListFanganDoc, params)
}

export const detail = (params) => {
  return get(Api.Detail, params)
}

export const productUpDetail = (params) => {
  return get(Api.ProductUpDetail, params)
}
export const productDetail = (params) => {
  return get(Api.ProductDetail, params)
}

export const getPriceList = (params = {}) => {
  return get(Api.Price, params)
}

export const downloadPdf = (params, productName, fanganName) => {
  return exportPdf(productName + "-" + fanganName, Api.DownloadPdf, params)
}

export const downloadExcel = (params, productName) => {
  return exportXls(productName, Api.DownloadExcel, params)
}

export async function addData(data, handleSuccess){
  post(Api.Add, data).then((res) => {
    createMessage.success( "添加成功")
    handleSuccess()
  });
}

export async function updateData(data, handleSuccess){
  post(Api.Edit, data).then((res) => {
    createMessage.success( "编辑成功")
    handleSuccess()
  });
}